<template>
  <menu-body></menu-body>
</template>

<script>
import MenuBody from '@/components/MenuBody.vue'
export default {
    name: 'HomeView',
    components: { 
        MenuBody
    }
}
</script>

<style>

</style>